import { createContext, useContext } from 'react';

/**
 * Tracks hover over the left rail strip so elements outside the rail's DOM
 * subtree can react to it. The drawer (LeftPaneMenu) renders through an MUI
 * Modal portal at document.body, so no CSS selector can bridge the rail's
 * `:hover` to the drawer's account avatar — this context carries it in JS.
 */
export const RailHoverContext = createContext<boolean>(false);

export const useRailHovered = () => useContext(RailHoverContext);
